module.exports = __webpack_public_path__ + "static/img/vote-03.fb7c490.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vote/vote-03.png
// module id = 2Mu2
// module chunks = 1